// eslint-disable  @typescript-eslint/no-inferrable-types
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ToolbarButtonDefinition } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/toolbar-button.type';

@Component({
  selector: 'xvi-action-button',
  templateUrl: './xvi-action-button.component.html',
  styleUrls: ['./xvi-action-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XviActionButtonComponent {
  @Output() public buttonClick: EventEmitter<string> =
    new EventEmitter<string>();
  @Input() public button: ToolbarButtonDefinition;

  public actionButtonClick(value: string): void {
    this.buttonClick.emit(value);
  }
}
